import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const Tabs = lazyImport(() => import('@mui/material/Tabs'), <div />)